import { useEffect, useState } from 'react';

/** 闊度小於 lg（992px）時用抽屜選單，適合平板直向與手機 */
export function useCrmNarrowLayout(breakpointPx = 992) {
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpointPx,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(min-width: ${breakpointPx}px)`);
    const sync = () => setNarrow(!mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, [breakpointPx]);

  return narrow;
}
